// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"b8b65186","2":"9a2dcee6","3":"7b244596"}[chunkId] + ".chunk.js";
};